'use client';

import { QueryKeys } from '@/constants/query-keys';
import { Configurations } from '@/types/configurations';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

type ConfigurationsProviderProps = {
  config: Configurations;
};

export const ConfigurationsProvider = ({ config }: ConfigurationsProviderProps): null => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.setQueryData(QueryKeys.global.configurations, config);
  }, [queryClient, config]);

  return null;
};
